import { localeIds } from 'locals';

export class RepositoryError {
  readonly status: number;
  readonly message?: string;
  readonly shouldNotRaiseError?: boolean;
  readonly details?: RepositoryErrorDetails;

  constructor(
    status: number,
    message?: string,
    shouldNotRaiseError?: boolean,
    details?: RepositoryErrorDetails
  ) {
    this.status = status;
    this.message = message;
    this.shouldNotRaiseError = shouldNotRaiseError;
    this.details = details;
  }
}

export interface RepositoryErrorDetails {
  [name: string]: RepositoryErrorDetail[];
}

export type RepositoryErrorDetail = {
  error: string;
};

export class InvalidParameterError extends Error {
  constructor(e?: string) {
    super(e);
  }
}

// APIから返される月間データ転送量上限超過のエラーメッセージ
export const MONTHLY_TRANSFER_LIMIT_EXCEEDED_MESSAGE =
  'monthly transfer limit exceeded';

const knownMessages: { [key: string]: string } = {
  'invalid email or password': localeIds.api.error.invalidEmailOrPassword,
  'distribution not found': localeIds.api.error.distributionNotFound,
  'some required params is blank.':
    localeIds.api.error.someRequiredParamsIsBlank,
  'not accepted terms': localeIds.api.error.notAcceptedTerms,
  'this name is already taken.': localeIds.api.error.thisNameIsAlreadyUsed,
  'this email is already in use.': localeIds.api.error.thisEmailIsAlreadyUsed,
  'token is invalid': localeIds.api.error.tokenIsInvalid,
  'no session found': localeIds.api.error.noSessionFound,
  'no enterprise found': localeIds.api.error.noEnterpriseFound,
  'SAML authentication disabled':
    localeIds.api.error.SamlAuthenticationDisabled,
  'Only letters, numbers, hyphens and underscores are allowed in a username.':
    localeIds.api.error.distributionDisplayNameInvalidCharacters,
  'invalid email': localeIds.api.error.invalidEmail,
  'this distribution limited accesses.':
    localeIds.api.error.thisDistributionLimitedAccesses,
  'This iphone was logged in by other account. Please try to login again.':
    localeIds.api.error.thisIphoneWasLooggedIn,
  'not found iphone': localeIds.api.error.notFoundIphone,
  'not connected to internet': localeIds.api.error.notConnectedToInternet,
  'This email is already in use.': localeIds.api.error.thisEmailIsAlreadyInUse,
  'These transaction key and code were invalid.':
    localeIds.api.error.theseTransactionKeyAndCodeWereInvalid,
  'The transaction key has been invalidated. Please resend the code.':
    localeIds.api.error.TheTransactionKeyHasBeenInvalidated,
  'Could not accept due to many similar requests. Please try again later.':
    localeIds.api.error.TooManyRequests,
  'Your device has logged out. The DeployGate account you are currently using needs to be migrated and cannot be used.':
    localeIds.api.error.SsoAuthDueDateOver,
  'This distribution no longer exists or you have to log-in to the correct account.':
    localeIds.api.error.NotFoundOrNeedToLogIn,
  [MONTHLY_TRANSFER_LIMIT_EXCEEDED_MESSAGE]:
    localeIds.api.error.monthlyTransferLimitExceeded,
  'name.too_short': localeIds.api.error.name.too_short,
  'name.too_long': localeIds.api.error.name.too_short,
  'name.invalid': localeIds.api.error.name.invalid,
  'name.taken': localeIds.api.error.name.taken,
  'password.length': localeIds.api.error.password.length,
};

export const apiErrorMessageLocaleId = (message?: string): string => {
  if (message === undefined) {
    return localeIds.api.error.general;
  }

  const id = knownMessages[message];
  if (id) {
    return id;
  }

  return message;
};
